import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

import { ButtonIconComponent } from '@blaze-shared/shared-ui';

@Component({
  selector: 'blaze-dataset-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dataset-group.component.html',
  styleUrls: ['./dataset-group.component.scss'],
  imports: [ButtonIconComponent, CommonModule, FormsModule, MatIcon],
})
export class DatasetGroupComponent {
  isAccessLogs = input(false);
  isChangeTracking = input(false);
  isSystemTable = input(false);

  isExpanded = signal(false);

  icon = computed(() => {
    if (this.isChangeTracking()) {
      return 'icon_dataset_group_tracking_32';
    } else if (this.isAccessLogs()) {
      return 'icon_access_logs_32';
    } else if (this.isSystemTable()) {
      return 'icon_dataset_group_system_32';
    }
    return 'icon_dataset_group_32';
  });

  toggleExpanded($event: Event): void {
    $event.stopPropagation();
    this.isExpanded.update((val) => !val);
  }
}
